<template>

</template>

<script>
export default {
  name: "fileStorage"
};
</script>

<style scoped lang="scss">

.about-us-page {
  width: 100%;

  .first-box {
    width: 100%;
    height: 520px;
    background: url("../../../public/static/indexUse/commonBg.png") no-repeat center / cover;
    position: relative;

    .bg-box {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(0, 0, 0, 0.3);
      z-index: 10;
      display: flex;
      align-items: flex-end;
    }

    .box-container {
      width: 1280px;
      margin: 0 auto;
      text-align: center;
      color: #fff;

      .page-title {
        font-size: 32px;
        font-weight: bold;
        line-height: 45px;
        margin-bottom: 24px;
      }
    }
  }
}
</style>
